<div class="catalog-content">
    <form
        name="form"
        (ngSubmit)="f.form.valid && processData()"
        #f="ngForm"
        novalidate
    >
        <div class="row">
            <div class="col-md-6">
                <!-- TYPE -->
                <div class="form-group padding-right-10">
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="Types"
                            [(ngModel)]="selectedType"
                            name="type"
                            #type="ngModel"
                            required
                            (selectionChange)="onTypeChange($event)"
                        >
                            <mat-option
                                *ngFor="let item of pdfTypes"
                                [value]="item.id"
                            >
                                {{ item.type }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <!-- TITLE -->
                <div class="form-group padding-right-10">
                    <mat-form-field>
                        <input
                            matInput
                            placeholder="Title"
                            [(ngModel)]="pdfName"
                            name="title"
                            #title="ngModel"
                            required
                        >
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div
            class="row"
            *ngIf="selectedType === 2 || selectedType === 4 || selectedType === 3 || selectedType === 7 || selectedType === 9"
        >
            <div [ngClass]="{
          'col-md-6': selectedType !== 2 && selectedType !== 7 && selectedType !== 9 && selectedMainTab !=='Expense Ratio',
          'col-md-12': selectedType === 2 || selectedType === 7 || selectedType === 9 || selectedMainTab =='Expense Ratio'
        }">
                <!-- SECTION -->
                <div class="form-group padding-right-10">
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="Section"
                            [(ngModel)]="selectedSection"
                            name="section"
                            #section="ngModel"
                            required
                            (selectionChange)="onSectionChange($event)"
                        >
                            <mat-option
                                *ngFor="let item of pdfSectionList"
                                [value]="item.id"
                            >
                                {{ item.sections }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <!-- SUB SECTION -->
                <div
                    class="form-group"
                    *ngIf="selectedType !== 2 && selectedType !== 7 && selectedType !== 9 && selectedMainTab !=='Expense Ratio'"
                >
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="Sub Section"
                            [(ngModel)]="selectedSubSection"
                            name="subsection"
                            #subsection="ngModel"
                            (selectionChange)="onSubSelectionChange($event)"
                        >
                            <mat-option
                                *ngFor="let item of pdfSubSectionList"
                                [value]="item.id"
                            >
                                {{ item.subSections }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <!--PROCESS SECTION-->
        <div class="row" *ngIf="selectedType === 8">
          <div class="col-md-12">
                <!-- SECTION -->
                <div class="form-group padding-right-10">
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="Section"
                            [(ngModel)]="selecteScheme"
                            name="section"
                            #section="ngModel"
                            required
                        >
                            <mat-option
                                *ngFor="let item of processSection"
                                [value]="item"
                            >
                                {{ item }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <!--Level 1 and Level 2-->
        <div
            class="row"
            *ngIf="selectedType === 4">
            <div [ngClass]="{
                'col-md-6': selectedMainTab !=='Expense Ratio',
                'col-md-12':selectedMainTab =='Expense Ratio'
              }">
                <!-- YEAR SECTION -->
                <div class="form-group padding-right-10">
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="Year"
                            [(ngModel)]="selectedYear"
                            name="year"
                            #year="ngModel"
                            (selectionChange)="onYearChange($event)"
                        >
                            <mat-option
                                *ngFor="let year of yearList"
                                [value]="year.year"
                            >
                                {{ year.year }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6" *ngIf="selectedMainTab !=='Expense Ratio'">
                <!-- MONTH SECTION -->
                <div
                    class="form-group">
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="Month"
                            [(ngModel)]="selectedMonth"
                            name="month"
                            #month="ngModel"
                            (selectionChange)="onMonthChange($event)"
                        >
                            <mat-option
                                *ngFor="let month of monthList"
                                [value]="month.month"
                            >
                                {{ month.month }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- SCHEME -->
        <div
            *ngIf="selectedType === 6"
            class="row"
        >
            <div class="col-md-12">
                <div class="form-group">
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="Scheme"
                            [(ngModel)]="selecteScheme"
                            name="Scheme"
                            #scheme="ngModel"
                            required
                            (selectionChange)="onSchemeChange($event)"
                        >
                            <mat-option
                                *ngFor="let scheme of schemeList"
                                [value]="scheme?.schemeCode"
                            >
                                {{ scheme?.schemeName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <!-- PDF UPLOAD -->
        <div class="form-group">
            <app-file-input
                (fileChange)="onFileChange($event)"
                [(ngModel)]="fileName"
                name="fileName"
                placeholder="Upload File"
                required="true"
            >
                <button
                    type="button"
                    mat-raised-button
                    color="primary"
                >
                    Choose
                </button>
            </app-file-input>
        </div>
        <div class="margin-top-20 text-center">
            <button
                mat-raised-button
                color="primary"
                class="mat-button-large"
                type="submit"
                [disabled]="!f.valid"
            >
                Submit
            </button>
        </div>
    </form>
    <app-forms-sebi
        *ngIf="selectedType === 5"
        [data]="mfpdfDataList"
    ></app-forms-sebi>
    <app-forms-updates
        *ngIf="selectedType === 1"
        [data]="mfpdfDataList"
    ></app-forms-updates>
    <app-forms-download
        *ngIf="selectedType === 2"
        [data]="mfpdfDataList"
    ></app-forms-download>
    <app-forms-collaterals
        *ngIf="selectedType === 3"
        [data]="patnerData"
    ></app-forms-collaterals>
    <app-forms-disclosure
        *ngIf="selectedType === 4"
        [data]="patnerData" [selectedMainTab]="selectedMainTab"
    ></app-forms-disclosure>
    <app-forms-scheme-documents
        *ngIf="selectedType === 6"
        [data]="patnerData"
    ></app-forms-scheme-documents>
    <app-catalog-investor-forms
    *ngIf="selectedType === 7"
    [data]="mfpdfDataList"
    ></app-catalog-investor-forms>
    <app-catalog-investor-process
    *ngIf="selectedType === 8"
    [data]="mfpdfDataList"
    ></app-catalog-investor-process>
    <app-investor-awareness-program-forms
    *ngIf="selectedType === 9"
    [data]="mfpdfDataList"
    ></app-investor-awareness-program-forms>
</div>
